const REPRESENTATIVE_LABELS = {
  "order-rep": "Order Rep",
  "client-rep": "Client Rep",
  "project-starter": "Project Started By",
};

export function getProductionRepresentativeLabel(source) {
  const normalizedSource = String(source || "").trim().toLowerCase();
  return REPRESENTATIVE_LABELS[normalizedSource] || null;
}
